<ng-template #userModalForm role="document" let-modal>
  
  <app-modal-comp-header
    [fileLockHoverText]="fileLockHoverText"
    [padlockIsLocked]="inviewAccountLocked"
    [showFileLockIcon]="formIsLocked"
    [showMessageIcon]="!newUser && showMessageIcon"
    [showPadlockIcon]="!newUser && portalUser && (curUser.systemAdmin || curUser.systemAdminStd)"
    [title]="formTitle"
    (cancelButtonOnClick)="userFormCancel()"
    (messageButtonOnClick)="messageClick()"
    (padlockButtonOnClick)="padLockClick()"
  ></app-modal-comp-header>
  
  <form
    autocomplete="off"
    [attr.autocomplete]="autofill ? 'on' : 'off'"
    class="tablelist-form"
    [formGroup]="userForm"
    (ngSubmit)="userFormSubmitAttempt()"
  >
    <div class="modal-body">

      <ul ngbNav #ArrowNgbNav="ngbNav" [(activeId)]="activeId" (navChange)="onTabChange($event)" class="nav nav-pills arrow-navtabs nav-success bg-light mb-3">

        <li [ngbNavItem]="navItemBasicDetails">
          <a ngbNavLink>
              <span class="d-block"><i class="ri-user-line"></i></span>
              <span class="d-sm-block">Basic Details</span>
          </a>
          <ng-template ngbNavContent>
 
             @if(newUser) {
             <div class="row">
               <div class="col-12">
                 <div class="mb-3">
                   <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
                     <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
                     <span [innerHtml]="progressInformation"></span>
                   </div>
                 </div>
               </div>
             </div>
             }
             
             @if(newUser) {
             <div class="row">
               <div class="col-12">
                 <div class="mb-3">
                   <label for="inviewCompanyId-field" class="form-label text-right"
                     [class.required]="isRequired('inviewCompanyId')"
                   >
                     Company
                   </label>
                   <div class="input-group">
                     <select
                       class="form-select"
                       name="inviewCompanyId-field"
                       id="inviewCompanyId-field"
                       formControlName="inviewCompanyId"
                       (change)="inviewCompanySelectDropDownChange($event)"
                       [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['inviewCompanyId'].errors }"
                     >
                       <option selected></option>
                       @for (object of getDropdownDataObjectArray("inviewCompanyId"); track object.id) {
                         <option [ngValue]="object.id">{{object.description}}</option>    
                       }
                     </select>
                     <!-- @if(!inviewCompanySelected){ -->
                     <button class="btn btn-success" type="button" (click)="addInviewCompany()">{{addInviewCompanyButtonText}}</button>
                     <!-- } -->
                     <div class="invalid-feedback">A value is required</div>
                   </div>
                 </div>
               </div>
             </div>
             }
             <!--
             @if(partialUserSearchEnabled) {
               <div class="row">
                 <div class="col-12">
                   <div class="mb-3">
                     <label for="partialUserSearch-field" class="form-label"
                       [class.required]="isRequired('partialUserSearch')"
                     >
                       Partial Search
                     </label>
                     <div class="input-group">
                       <input
                         [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                         [attr.name]="autofill ? 'partialUserSearch-field' : 'partialUserSearch-field-secret'"
                         class="form-control"
                         data-lpignore="true"
                         formControlName="partialUserSearch"
                         id="partialUserSearch-field"
                         placeholder="example@domain"
                         type="text"
                       />
                       <button class="btn btn-success" type="button" (click)="partialInviewUserSearch()">Search</button>
                     </div>
                   </div>
                 </div>
               </div>
             }
             -->
             @if(newUser && inviewCompanySelected) {
             <div class="row">
               <div class="col-12">
                 <div class="mb-3">
                   <label for="inviewUserId-field" class="form-label text-right"
                     [class.required]="isRequired('inviewUserId')"
                   >
                     User
                   </label>
                   <div class="input-group">
                     <select
                       class="form-select"
                       name="inviewUserId-field"
                       id="inviewUserId-field"
                       formControlName="inviewUserId"
                       (change)="inviewUserSelectDropDownChange($event)"
                       [ngClass]="{ 'is-invalid': (userFormSubmitted && formOfUserAdd['inviewUserId'].errors) }"
                     >
                       <!-- [ngClass]="{ 'is-invalid': (userFormSubmitted && formOfUserAdd['inviewUserId'].errors) || partialUserSearchEnabled }" -->
                       <option selected></option>
                       @for (object of getDropdownDataObjectArray_InviewUser(); track object.userID) {
                         <option [ngValue]="object.userID">{{getInviewUserLabel(object)}}</option>
                       }
                     </select>
                     @if (searchForInviewUser && !inputInviewUserId) {
                       <button class="btn btn-success" type="button" (click)="_searchForInviewUser()">Search for User</button>
                     }
                     <!--
                     @if (partialUserSearchEnabled) {
                       @if (haveInviewUserData) {
                         <div class="invalid-feedback">Select a user</div>
                       } @else {
                         <div class="invalid-feedback">No user data to select</div>
                       }
                     } @else {
                     --> 
                       <div class="invalid-feedback">A value is required</div>
                     <!-- } -->
                   </div>
                 </div>
               </div>
             </div>
             }
       
             @if(userOrIotDeviceRadiosVisible()) {
               <div class="row">
                 <div class="col-12 mb-3 d-flex flex-column align-items-center">
                   
                   <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                     <input type="radio" class="btn-check" name="userOrIotDevice" id="userRadio"
                            formControlName="userOrIotDevice" [value]="'user'"
                            (change)="userOrIotDeviceChange('user')"
                     >
                     <label class="btn btn-outline-success mb-0" for="userRadio">For Physical User</label>
                   
                     <input type="radio" class="btn-check" name="userOrIotDevice" id="iotDeviceRadio"
                            formControlName="userOrIotDevice" [value]="'iotDevice'"
                            (change)="userOrIotDeviceChange('iotDevice')"
                     >
                     <label class="btn btn-outline-success mb-0" for="iotDeviceRadio">For IOT Device</label>
                   </div>
                   
                   <div *ngIf="userFormSubmitted && formOfUserAdd['userOrIotDevice'].errors" class="invalid-feedback d-block text-center mt-1">
                     Select one of these
                   </div>
                   
                 </div>
               </div>
             }
             
             @if((createNewUserSelected && isIotDevice != undefined) || inviewUserSelected || !newUser) {
               
               <ng-template #userRoleField>
                 <div class="mb-3">
                   <label for="accessTypeId-field" class="form-label text-right"
                     [class.required]="isRequired('accessTypeId')"
                   >
                     User Role
                   </label>
                   <div class="input-group">
                     <select
                       [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                       class="form-select"
                       name="accessTypeId-field"
                       id="accessTypeId-field"
                       formControlName="accessTypeId"
                       [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['accessTypeId'].errors }"
                     >
                       <option selected></option>
                       @for (object of getDropdownDataObjectArray("accessTypeId"); track object.id) {
                         <option [ngValue]="object.id">{{object.description}}</option>
                       }
                     </select>
                     <div class="invalid-feedback">A value is required</div>
                   </div>
                 </div>
               </ng-template>

               <ng-template #occupationField>
                 <div class="mb-3">
                   <label for="occupationTypeId-field" class="form-label text-right"
                     [class.required]="isRequired('occupationTypeId')"
                   >
                     Occupation
                   </label>
                   <div class="input-group">
                     <select
                       [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                       class="form-select"
                       name="occupationTypeId-field"
                       id="occupationTypeId-field"
                       formControlName="occupationTypeId"
                       [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['occupationTypeId'].errors }"
                     >
                       <option selected></option>
                       @for (object of getDropdownDataObjectArray("occupationTypeId"); track object.id) {
                         <option [ngValue]="object.id">{{object.description}}</option>
                       }
                     </select>
                     <div class="invalid-feedback">A value is required</div>
                   </div>
                 </div>
               </ng-template>

               <ng-template #countryField>
                 <div class="mb-3">
                   <label for="countryId-field" class="form-label text-right"
                     [class.required]="isRequired('countryId')"
                   >
                     Home Country
                   </label>
                   <select
                     class="form-select"
                     name="countryId-field"
                     id="countryId-field"
                     formControlName="countryId"
                     [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['countryId'].errors }"
                   >
                     <option selected></option>
                     @for (object of getDropdownDataObjectArray("countryId"); track object.id) {
                       <option [ngValue]="object.id">{{object.description}}</option>
                     }
                   </select>
                   <div class="invalid-feedback">A value is required</div>
                 </div>
               </ng-template>

               @if (portalUser && showOccupation && !isIotDevice) {
                 @if (showUserRole) {
                   <div class="row">
                     <div class="col-12">
                       <ng-container *ngTemplateOutlet="userRoleField"></ng-container>
                     </div>
                   </div>
                 }
                 <div class="row">
                   <div class="col-6">
                     <ng-container *ngTemplateOutlet="occupationField"></ng-container>
                   </div>
                   <div class="col-6">
                     <ng-container *ngTemplateOutlet="countryField"></ng-container>
                   </div>
                 </div>
               } @else {
                 <div class="row">
                   @if (portalUser && showUserRole) {
                     <div class="col-6">
                       <ng-container *ngTemplateOutlet="userRoleField"></ng-container>
                     </div>
                   }
                   @if (showOccupation && !isIotDevice) {
                     <div class="col-6">
                       <ng-container *ngTemplateOutlet="occupationField"></ng-container>
                     </div>
                   }
                   <div class="col-6">
                     <ng-container *ngTemplateOutlet="countryField"></ng-container>
                   </div>
                 </div>
               }
             
               <div class="row">
                 <div class="col-6">
                   <div class="mb-3">
                     <label for="firstname-field" class="form-label"
                       [class.required]="isRequired('firstname')"
                     >
                       {{isIotDevice ? "Location ID" : "Firstname"}}
                     </label>
                     <input
                       [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                       [attr.name]="autofill ? 'firstname-field' : 'firstname-field-secret'"
                       class="form-control"
                       data-lpignore="true"
                       formControlName="firstname"
                       id="firstname-field"
                       [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['firstname'].errors }"
                       placeholder=""
                       type="text"
                     />
                     @if(formOfUserAdd['firstname'].hasError('maxlength')) {
                       <div class="invalid-feedback">Maximum length of {{firstnameMaxLength}} characters has been exceeded</div>
                     } @else {
                       <div class="invalid-feedback">A value is required</div>
                     }
                   </div>
                 </div>  
                 <div class="col-6">
                   <div class="mb-3">
                     <label for="lastname-field" class="form-label"
                       [class.required]="isRequired('lastname')"
                     >
                       {{isIotDevice ? "Asset ID" : "Lastname"}}
                     </label>
                     <input
                       [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                       [attr.name]="autofill ? 'lastname-field' : 'lastname-field-secret'"
                       class="form-control"
                       data-lpignore="true"
                       formControlName="lastname"
                       id="lastname-field"
                       [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['lastname'].errors }"
                       placeholder=""
                       type="text"
                     />
                     @if(formOfUserAdd['lastname'].hasError('maxlength')) {
                       <div class="invalid-feedback">Maximum length of {{lastnameMaxLength}} characters has been exceeded</div>
                     } @else {
                       <div class="invalid-feedback">A value is required</div>
                     }
                   </div>
                 </div>
               </div>
               
               @if (!isIotDevice || showUsernameAndMobileWhenDevice) {
                 <div class="row">
                   <div class="col-6">
                     <div class="mb-3">
                       <label for="username-field" class="form-label"
                         [class.required]="isRequired('username')"
                       >
                         @if (associateUser) {
                           Email
                         } @else {
                           Username (email) <span class="text-danger small">{{isIotDevice ? " Visible to SureSIM Admin only" : ""}}</span>
                         }
                       </label>
                       <input
                         [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                         [attr.name]="autofill ? 'username-field' : 'username-field-secret'"
                         class="form-control"
                         data-lpignore="true"
                         formControlName="username"
                         id="username-field"
                         [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['username'].errors }"
                         placeholder=""
                         type="text"
                       />
                       
                       @if(formOfUserAdd['username'].hasError('maxlength')) {
                         <div class="invalid-feedback">Maximum length of {{usernameMaxLength}} characters has been exceeded</div>
                       } @else if(formOfUserAdd['username'].hasError('email')) {
                         <div class="invalid-feedback">Value is not a valid e-mail address</div>
                       } @else {
                         <div class="invalid-feedback">A value is required</div>
                       }
                     </div>
                   </div>
                   <!--
                   <div class="col-6">
                     <div class="mb-3">
                       <label for="email-field" class="form-label"
                         [class.required]="isRequired('email')"
                       >
                         Email
                       </label>
                       <input
                         [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                         [attr.name]="autofill ? 'email-field' : 'email-field-secret'"
                         class="form-control"
                         data-lpignore="true"
                         formControlName="email"
                         id="email-field"
                         [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['email'].errors }"
                         placeholder=""
                         type="text"
                         (keyup)="emailkeyup($event)"
                       />
                         @if(formOfUserAdd['email'].hasError('maxlength')) {
                           <div class="invalid-feedback">Maximum length of {{emailMaxLength}} characters has been exceeded</div>
                         } @else if(formOfUserAdd['email'].hasError('email')) {
                           <div class="invalid-feedback">Value is not a valid e-mail address</div>
                         } @else {
                           <div class="invalid-feedback">A value is required</div>
                         }
                     </div>
                   </div>
                   -->
                   <div class="col-6" [hidden]="useInternationalDialCode">
                     <div class="mb-3">
                       <label for="mobilenumber-field" class="form-label"
                         [class.required]="isRequired('mobilenumber')"
                       >
                         Mobile <span class="text-danger small">{{isIotDevice ? " Visible to SureSIM Admin only" : ""}}</span>
                       </label>
                       <input
                         [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                         [attr.name]="autofill ? 'mobilenumber-field' : 'mobilenumber-field-secret'"
                         class="form-control text-end"
                         data-lpignore="true"
                         formControlName="mobilenumber"
                         id="mobilenumber-field"
                         [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['mobilenumber'].errors }"
                         placeholder=""
                         type="text"
                       />
                       @if(formOfUserAdd['mobilenumber'].hasError('maxlength')) {
                         <div class="invalid-feedback">Maximum length of {{mobilenumberMaxLength}} characters has been exceeded</div>
                       } @else {
                         <div class="invalid-feedback">A value is required</div>
                       }
                     </div>
                   </div>
                   @if (useInternationalDialCode) {
                     <div class="col-6">
                       <div class="mb-3">
                         <app-dropdown-country-dialling-code
                           #dialCodeDropdown
                           [mobileNumber]="formOfUserAdd['mobilenumber'].value"
                           [mobileNumberIntCode]="formOfUserAdd['mobilenumberIntCode'].value"
                           [requiredAsterisk]="newUser"
                           (valueChanged)="dialCodeChanged()"
                         >
                         </app-dropdown-country-dialling-code>
                       </div>
                     </div>
                   }
                 </div>
               }
               
               <div class="row">
                 <div class="col-6">
                   <div class="mb-3">
                     <label for="customerTag-field" class="form-label"
                       [class.required]="isRequired('customerTag')"
                     >
                       {{fieldAliasTag}}
                     </label>
                     <input
                       [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                       [attr.name]="autofill ? 'customerTag-field' : 'customerTag-field-secret'"
                       class="form-control"
                       data-lpignore="true"
                       formControlName="customerTag"
                       id="customerTag-field"
                       [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['customerTag'].errors }"
                       placeholder=""
                       type="text"
                     />
                     @if(formOfUserAdd['customerTag'].hasError('maxlength')) {
                       <div class="invalid-feedback">Maximum length of {{customerTagMaxLength}} characters has been exceeded</div>
                     } @else {
                       <div class="invalid-feedback">A value is required</div>
                     }
                   </div> 
                 </div>
                 <div class="col-6">
                   <div class="mb-3">
                     <label for="customerTag2-field" class="form-label"
                       [class.required]="isRequired('customerTag2')"
                     >
                       {{fieldAliasTag2}}
                     </label>
                     <input
                       [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                       [attr.name]="autofill ? 'customerTag2-field' : 'customerTag2-field-secret'"
                       class="form-control"
                       data-lpignore="true"
                       formControlName="customerTag2"
                       id="customerTag2-field"
                       [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['customerTag2'].errors }"
                       placeholder=""
                       type="text"
                     />
                     @if(formOfUserAdd['customerTag2'].hasError('maxlength')) {
                       <div class="invalid-feedback">Maximum length of {{customerTag2MaxLength}} characters has been exceeded</div>
                     } @else {
                       <div class="invalid-feedback">A value is required</div>
                     }
                   </div> 
                 </div>
               </div>
               
               @if (portalUser && !newUser && (curUser.systemAdmin || curUser.systemAdminStd)) {
                 <div class="row">
                   <div class="col-6">
                     <div class="mb-3">
                       <label for="passwordEncTemp-field" class="form-label"
                         [class.required]="isRequired('passwordEncTemp')"
                       >
                         Temp Password
                       </label>
                       <input
                         [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                         [attr.name]="autofill ? 'passwordEncTemp-field' : 'passwordEncTemp-field-secret'"
                         class="form-control border-0 text-bg-light"
                         formControlName="passwordEncTemp"
                         id="passwordEncTemp-field"
                         placeholder=""
                         readonly
                         type="text"
                       />
                     </div> 
                   </div>
                 </div>
               }
       
               @if(costCentreCheckBoxVisible()) {
                 <div class="row">
                   <div class="col-12">
                     <div class="form-check form-switch form-switch-md mb-3">
                       <input class="form-check-input" type="checkbox" role="switch" id="use-cost-centres-field"
                         formControlName="useCostCentres"
                         (change)="useCostCentresChange()">
                       <label class="form-check-label" for="use-cost-centres-field">Cost Centres</label>
                     </div>
                   </div>
                 </div>
               }
               
               @if (false) {
                 <div class="row">
                   <div class="col-6">
                     <div class="mb-3">
                       <div class="form-check form-switch form-switch-md">
                         <label class="form-check-label" for="suresim-access-field">SureSIM Access</label>
                         <input class="form-check-input" type="checkbox" role="switch" id="suresim-access-field" formControlName="hasSureSIMAccess">
                       </div>
                     </div> 
                   </div>
                 </div>
               }
             }

             @if(costCentreDropdownsVisible()) {
             <div class="row">
               <div class="col-6">
                 <div class="mb-3">
                   <label for="inviewCostCentreIdLv2-field" class="form-label text-right"
                     [class.required]="isRequired('inviewCostCentreIdLv2')"
                   >
                     Cost Centre Level 2
                   </label>
                   <div class="input-group">
                     <select
                       class="form-select"
                       name="inviewCostCentreIdLv2-field"
                       id="inviewCostCentreIdLv2-field"
                       formControlName="inviewCostCentreIdLv2"
                       (change)="costCentreLv2SelectDropDownChange($event)"
                       [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['inviewCostCentreIdLv2'].errors }"
                     >
                       <option selected></option>
                       @for (object of getDropdownDataObjectArray("inviewCostCentreIdLv2"); track object.id) {
                         <option [ngValue]="object.id">{{object.description}}</option>    
                       }
                     </select>
                     @if((newUser && createNewUserSelected) || costCentreMissingInInview){
                       <button class="btn btn-success" type="button" (click)="addNewCostCentre(2, addNewCostCentreContent)">Add</button>
                     }
                     <div class="invalid-feedback">A value is required</div>
                   </div>
                 </div>
               </div>  
               <div class="col-6">
                 <div class="mb-3">
                   <label for="inviewCostCentreIdLv1-field" class="form-label text-right"
                     [class.required]="isRequired('inviewCostCentreIdLv1')"
                   >
                     Cost Centre Level 1
                   </label>
                   <div class="input-group">
                     <select
                       class="form-select"
                       name="inviewCostCentreIdLv1-field"
                       id="inviewCostCentreIdLv1-field"
                       formControlName="inviewCostCentreIdLv1"
                       (change)="costCentreLv1SelectDropDownChange($event)"
                       [ngClass]="{ 'is-invalid': userFormSubmitted && formOfUserAdd['inviewCostCentreIdLv1'].errors }"
                     >
                       <option selected></option>
                       @for (object of getDropdownDataObjectArray("inviewCostCentreIdLv1"); track object.id) {
                         <option [ngValue]="object.id">{{object.description}}</option>    
                       }
                     </select>
                     @if((newUser && createNewUserSelected) || costCentreMissingInInview){
                       <button class="btn btn-success" type="button" [disabled]="!costCentreLv1ButtonEnabled" (click)="addNewCostCentre(1, addNewCostCentreContent)">Add</button>
                     }
                     <div class="invalid-feedback">A value is required</div>
                   </div>
                 </div>
               </div>
             </div>
             }
             
             @if(createNewUserSelected || inviewUserSelected || !newUser) {
               @if (showActive) {
                 <div class="row">
                   <div class="col-12">
                     <div class="form-check form-switch form-switch-md">
                       <label class="form-check-label" for="active-field">Active</label>
                       <input class="form-check-input" type="checkbox" role="switch" id="active-field" formControlName="active" (click)="activeClick()">
                     </div>
                   </div>
                 </div>
               }
       
               @if (showBillRecipient) {
                 <div class="row">
                   <div class="col-12">
                     <div class="form-check form-switch form-switch-md">
                       <label class="form-check-label" for="sendBill-field">Bill Recipient</label>
                       <input class="form-check-input" type="checkbox" role="switch" id="sendBill-field" formControlName="sendBill">
                     </div>
                   </div>
                 </div>
               }
             }
          </ng-template>
        </li>
        @if (showUserGroups && !associateUser && !portalUser) {
          <li [ngbNavItem]="navItemGroups">
            <a ngbNavLink>
              <span class="d-block"><i class="bi-people"></i></span>
              <span class="d-sm-block">Groups</span>
            </a>
            <ng-template ngbNavContent>
              @if(!newUser) {
                <user-groups #userGroups
                  [companyId]="sureSimUser?.companyID"
                  [groupView]="false"
                  [newUser]="newUser"
                  [userId]="sureSimUser?.id"
                  [userView]="true"
                  (addButtonClick)="addGroup()"
                  (deleteButtonClick)="deleteButtonClick($event)"
                >
                </user-groups>
              } @else {
                <div class="row">
                  <div class="col-12">
                    <div class="mb-3">
                      <label class="form-label text-right"></label>
                      <div class="alert border-0 alert-primary" role="alert">
                        <strong>Information</strong><span> - Please save the user details before assigning groups.</span>
                      </div>
                    </div>
                  </div>
                </div>
              } 
            </ng-template>
          </li>
        }
        @if (showSupport && !associateUser) {
          <li [ngbNavItem]="navItemSupport">
            <a ngbNavLink>
              <span class="d-block"><i class="bi-ticket-perforated"></i></span>
              <span class="d-sm-block">Support</span>
            </a>
            <ng-template ngbNavContent>
              <div>
                <div class="row">
                  <div class="col-12">
                    <app-manage-tickets
                         [companyId]="this.sureSimUser?.companyID"
                         [initialInviewCompanyId]="this.sureSimUser?.companyID"
                         [initialInviewUserId]="this.sureSimUser?.id"
                         [initialSureSimDeviceId]="-1"
                         [isCompany]="false"
                         [isDevice]="false"
                         [isUser]="true"
                         [matchCompanyAndUser]="true"
                         [newUser]="newUser"
                         [userId]="sureSimUserId"
                    ></app-manage-tickets>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        }
      </ul>

      <div class="tab-content">
        <div [ngbNavOutlet]="ArrowNgbNav"></div>
      </div>

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        @if (btn2FaVisible()) {
          <button
            class="btn btn-danger"
            [disabled]="formIsLocked"
            id="2Fa-reset-btn"
            type="button"
            (click)="reset2Fa()"
          >
            Reset 2FA
          </button>
        }
        @if (btnPasswordVisible()) {
          <button
            class="btn btn-danger"
            [disabled]="formIsLocked"
            id="password-reset-btn"
            type="button"
            (click)="resetPassword()"
          >
            Reset Password
          </button>
        }
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="userFormCancel()">Close</button>
        <button type="submit" [disabled]="!submitButtonEnabled || formIsLocked" class="btn btn-success" id="add-btn">Submit</button>
      </div>
    </div>
  </form>    
</ng-template>

<ng-template #addNewCostCentreContent role="document" let-modal>
  <div class="modal-header bg-light p-3">
    <h4 class="modal-title" id="costCentreAddTitle">Add Cost Centre - Level {{costCentreLevel}}</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <form (ngSubmit)="costCentreAddFormSubmit()" [formGroup]="costCentreAddForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">
      <div class="mb-3">
        <label for="costCentreName-field" class="form-label">Cost Centre Name</label>
        <input
          [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
          [attr.name]="autofill ? 'costCentreName-field' : 'costCentreName-field-secret'"
          class="form-control"
          formControlName="costCentreName"
          id="costCentreName-field"
          [ngClass]="{ 'is-invalid': costCentreAddFormSubmitted && formOfCostCentreAdd['costCentreName'].errors }"
          placeholder=""
          type="text"
        />
        <div class="invalid-feedback">A value is required</div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
        <button type="submit" class="btn btn-success" id="add-cc-btn">Add</button>
      </div>
    </div>
  </form> 
</ng-template>

<app-communication-modal-form #communicationModalForm
  [initialSureSimCompanyId]="sureSimUser?.companyID"
  [initialSureSimUserId]="sureSimUser?.id"
  (formCancelled)="communicationFormHasBeenCancelled()"
  (dataHasBeenSaved)="communicationDataHasBeenSaved($event)"
></app-communication-modal-form>

@if (showComposeForm) {
  <app-communication-compose-modal-form #communicationComposeModalForm
    (formCancelled)="communicationFormHasBeenCancelled()"
    (dataHasBeenSaved)="communicationDataHasBeenSaved($event)"
  ></app-communication-compose-modal-form>
}

@if (disableCompanyModal == undefined || !disableCompanyModal) {
  <app-company-modal-form #companyModalForm
  [forceCreateNewCompany]="createNewCompany"
  [inputInviewCompanyId]="this.selectedInviewCompanyId"
  (inviewCompanyDataHasBeenSaved)="inviewCompanyHasBeenSaved($event)"
></app-company-modal-form>
}

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-confirmation-modal-form #userGroupConfirmModal
  (modalYes)="yesRemoveAllocation()"
></app-confirmation-modal-form>

<app-confirmation-modal-form #reset2FaConfirmModal
  (modalYes)="yesReset2Fa()"
></app-confirmation-modal-form>

<app-confirmation-modal-form #resetPasswordConfirmModal
  (modalYes)="yesResetPassword()"
></app-confirmation-modal-form>

<app-user-groups-modal-edit-form #userGroupModalForm
  (userGroupDataHasBeenSaved)="refreshGroups()"
></app-user-groups-modal-edit-form>

<app-user-modal-form-search #userSearchForm
  [portalUsers]="portalUser"
  (searchFormCancelled)="searchFormCancelled()"
  (searchGridRowClick)="searchGridRowClick($event)"
  (searchGridRowDblClick)="searchGridRowClick($event)"
></app-user-modal-form-search>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
